export default __webpack_public_path__ + "static/media/launch.d370cf5f.png";